import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import './style.css';
//import Table from 'react-bootstrap/Table';



const DebitCredit = () => {

    const [clients, setClients] = useState([]);
    const [selectedClid, setSelectedClid] = useState('');
    const [clientName, setClientName] = useState('');
    const [date, setDate] = useState('');
    const [debit, setDebit] = useState('');
    const [credit, setCredit] = useState('');

    const handleDebitChange = (e) => {
        setDebit(e.target.value);

        // Disable credit input if debit has a value
        if (e.target.value !== '') {
            setCredit(''); // Reset credit field when debit is filled
        }
    };

    // Handle credit field change
    const handleCreditChange = (e) => {
        setCredit(e.target.value);

        // Disable debit input if credit has a value
        if (e.target.value !== '') {
            setDebit(''); // Reset debit field when credit is filled
        }
    };

    // Fetch clients on component mount
    useEffect(() => {
        axios.get('https://react-apis.dotlocalhost.com/showClients.php')
            .then(response => {
                setClients(response.data);
            })
            .catch(error => {
                console.error('There was an error fetching the clients!', error);
            });
    }, []);

    // Fetch client name when clid is selected
    useEffect(() => {
        if (selectedClid) {
            axios.post('https://react-apis.dotlocalhost.com/showClientName.php', { clid: selectedClid })
                .then(response => {
                    setClientName(response.data.clientName);
                })
                .catch(error => {
                    console.error('There was an error fetching the client name!', error);
                });
        }


        // sidebar background color set
        // Change background color of the specific sidebar item
        const sidebarItemmain = document.getElementById("accnt");
        if (sidebarItemmain) {
            sidebarItemmain.style.backgroundColor = "#C0D4D9"; // Set the color when this component is loaded
            sidebarItemmain.style.color = "#000000";
        }
        const sidebarItem = document.getElementById("dbcr");
        if (sidebarItem) {
            sidebarItem.style.backgroundColor = "#CFE2E7"; // Set the color when this component is loaded
            sidebarItem.style.color = "#000000";
        }        


        // Cleanup function to reset the background color when component unmounts
        return () => {
            if (sidebarItemmain) {
                sidebarItemmain.style.backgroundColor = ""; // Reset to default when component unmounts
                sidebarItemmain.style.color = "#000000"
            }
            if (sidebarItem) {
                sidebarItem.style.backgroundColor = ""; // Reset to default when component unmounts
                sidebarItem.style.color = "#000000";
            }            
        };

    }, [selectedClid]);

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();

        const cashTransferData = {
            date,
            clid: selectedClid,
            debit: debit || 0,
            credit: credit || 0,
        };

        console.log('Submitting Data:', cashTransferData); // Add this to log the data

        axios.post('https://react-apis.dotlocalhost.com/insertCashTransfer.php', cashTransferData)
            .then(response => {
                if (response.data.success) {
                    alert('Data successfully inserted!');

                    // Clear all fields after successful submission
                    setDate('');
                    setSelectedClid('');
                    setClientName('');
                    setDebit('');
                    setCredit('');
                } else {
                    alert('Failed to insert data: ' + response.data.error);
                }
            })
            .catch(error => {
                console.error('There was an error submitting the form!', error);
            });
    };



    return (
        <div className="wrapper">
            <Sidebar />
            <div id="content">
                <Navbar />
                <div className='ineerBody'>
                    <div className='row'>
                        <div className='col-md-12 mb-5'>
                            <h3>Add Debit & Credit</h3>
                        </div>
                    </div>

                    <form onSubmit={handleSubmit}>

                        <div className='row'>
                            <div className='col-3'>
                                <label htmlFor="" className="form-label">Date</label>                        
                                <input className='form-control' type="date" value={date} onChange={(e) => setDate(e.target.value)} required />
                            </div>
                            <div className='col-2'>
                                <label htmlFor="" className="form-label">Client ID</label>                        
                                <select className='form-control' value={selectedClid} onChange={(e) => setSelectedClid(e.target.value)} required>
                                    <option value="">Select Client</option>
                                    {clients.map(client => (
                                        <option key={client.clid} value={client.clid}>
                                            {client.clid}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className='col-2'>
                                <label htmlFor="" className="form-label">Client Name</label>                        
                                <input className='form-control' type="text" value={clientName} disabled />
                            </div>
                            <div className='col-2'>
                                <label htmlFor="" className="form-label">Debit</label>                        
                                <input className='form-control' type="number" value={debit} onChange={handleDebitChange} disabled={!!credit} />
                            </div>
                            <div className='col-2'>
                                <label htmlFor="" className="form-label">Credit</label>                        
                                <input className='form-control' type="number" value={credit} onChange={handleCreditChange} disabled={!!debit} />
                            </div>
                        </div>

                        <div className="row">
                            <div className='col-6 mt-3 mb-5'>
                                <div className="d-grid gap-3">
                                    <input type="submit" name="submit" value="Submit" className="btn btn-primary btn-block" />
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default DebitCredit;
